<template>
<div class="block block-themed">
    <div class="col-md-12">
        <div class="bg-primary-dark">
            <section class="content content-full content-boxed">
                <!-- Section Content -->
                <div class="push-10-t push-10 text-center">
                    <h1 class="h2 text-white push-10"  data-class="animated fadeInDown">{{labelTopTitle01[actualLanguage]}}</h1>
                    <h1 class="h3 text-white push-10"  data-class="animated fadeInDown">{{labelTopTitle02[actualLanguage]}} {{policyEndPoint}}</h1>
                    <h2 class="h5 text-white-op"  data-class="animated fadeInDown">{{labelTopTitle03[actualLanguage]}}</h2>
                    <h2 class="h5 text-white-op"  data-class="animated fadeInDown">{{labelTopTitle04[actualLanguage]}}</h2>
                </div>
                <!-- END Section Content -->
            </section>
        </div>


        <div class="col-md-12">

            <div class="col-xs-12 col-md-12">
                <div class="push-10-t push-10 text-center">
                    <h4 data-class="animated fadeInDown">{{labelTopFilePreview[actualLanguage]}}</h4>
                </div> 
            </div>

            <div class="col-xs-12 col-md-6">
                <p><img class = "img-responsive" width="600px" @click="openUtilizationConditions()" :src="`politicsPreview/${policyConditionUtilizationPreviewImg[actualLanguage]}` | s3Image"></p>
            </div>

            <div class="col-xs-12 col-md-6">
                <p><img class = "img-responsive" width="600px" @click="openConfidentialityPolitics()" :src="`politicsPreview/${policyConfidentialPoliticsPreviewImg[actualLanguage]}` | s3Image"></p>
            </div>



            <div class="col-ms-12">
                <label class="css-input css-checkbox css-checkbox-lg css-checkbox-success align-center">
                    <div class="col-ms-6">
                        <h3><input type="checkbox" checked v-model="acceptConditionFlag"><span ></span>{{labelConfirmCheckBox[actualLanguage]}}</h3>
                    </div>        
                </label>
            </div>
            
            <hr>
            <div v-if= "acceptConditionFlag" class="col-ms-12">
                <div class="block">
                    <h3 class="h5 font-w600 text-uppercase push-10">{{labelCookiesTitle[actualLanguage]}}</h3>
                    <p>{{labelConfirmCookiesConditions[actualLanguage]}}</p>


                    <label class="css-input css-checkbox css-checkbox-lg css-checkbox-success align-center">
                        <div class="col-ms-6">
                            <h3><input type="checkbox" checked v-model="acceptCookieFlag"><span ></span>{{labelConfirmCookiesCheckBox[actualLanguage]}}</h3>
                        </div>        
                    </label>
                </div>
            </div>


            <div  v-if= "acceptCookieFlag" class="col-xs-12">
                <p><button @click="saveMyAgreement()" type="button" class="btn btn-success align-left" name="button">{{labelButtonAcceptCondition[actualLanguage]}}</button></p>
            </div>
    
    
    
        </div>

    </div>
</div>
</template>

<script>

import { mapState, mapGetters, mapActions } from 'vuex'
import moment from 'moment';

export default {
  name: 'policyAgreement',

  components: {

  },

  data() {
    return {
        actualLanguage : "FR",
        acceptConditionFlag:false,
        acceptCookieFlag:false,
        labelButton4Weeks: {FR: '4 semaines', EN: '4 weeks'},

        policyEndPoint : process.env.VAR_POLICY_ENDPOINT,
        policyCompany : process.env.VAR_POLICY_COMPANY,
        policyEmailSupport : process.env.VAR_POLICY_EMAIL_SUPPORT,
        policyEmailInfo : process.env.VAR_POLICY_EMAIL_INFO,

        policyConditionUtilizationPreviewImg : { FR: process.env.VAR_CONDITION_UTILIZATION_PREVIEW_IMG_FR,
                                                EN: process.env.VAR_CONDITION_UTILIZATION_PREVIEW_IMG_EN},
        policyConfidentialPoliticsPreviewImg : { FR: process.env.VAR_POLICY_PREVIEW_IMG_FR,
                                                EN: process.env.VAR_POLICY_PREVIEW_IMG_EN},


        labelTopTitle01: { FR: "Conditions générales d'utilisation.",
                        EN: "General terms of use."},
        labelTopTitle02: { FR: "de",
                        EN: "of"},
        labelTopTitle03: { FR: "Date de dernière mise à jour: 22 Novembre 2019",
                        EN: "Last update: 22 November 2019"},
        labelTopTitle04: { FR: "Vous devez confirmer et accepter les termes au bas de la page.",
                        EN: "You must accept and confirm the terms in the bottom of this page"},



        labelTopTitle01: { FR: "Conditions générales d'utilisation.",
                        EN: "General terms of use."},
        labelTopTitle02: { FR: "de",
                        EN: "of"},
        labelTopTitle03: { FR: "Date de dernière mise à jour: 22 Novembre 2019",
                        EN: "Last update: 22 November 2019"},
        labelTopTitle04: { FR: "Vous devez confirmer et accepter les termes au bas de la page.",
                        EN: "You must accept and confirm the terms in the bottom of this page"},

        labelTopFilePreview: { FR: "Il vous suffit de cliquer sur les images pour voir les documents.",
                        EN: "You only have to click on pictures to see each document"},

        labelConfidentialityPolicy: { FR: "Politique de confidentialité",
                        EN: "Confidentiality policy"},

        labelTitle22: { },
        labelText22: { },

        labelConfirmCheckBox: { FR: "Je confirme avoir pris connaissance des conditions d'utilisation.",
                        EN: "I confirm that I have read the terms of use."},
 

        labelCookiesTitle: { FR: "Utilisation des cookies",
                        EN: "Cookies"},
        labelConfirmCookiesConditions: { FR: "Le site web evsenscloud.com nécessite l'utilisation des cookies et des technologies de suivi similaires. Si vous n'acceptez pas les cookies, il vous sera impossible d'ouvrir votre profil du portail web.",
                        EN: "The evsenscloud.com web site required cookies or similar technologies usage. If you not accept the cookie usage, it will not be possible to access the web portal."},
        labelConfirmCookiesCheckBox: { FR: "J'autorise l'utilisation des cookies.",
                        EN: "I authorize the use of cookies."},

        labelButtonAcceptCondition: { FR: "J'accepte les conditions",
                        EN: "I accept the conditions"},


    }
  },

  methods: {

    refresh() {
        
        if(localStorage.language){this.actualLanguage =  localStorage.language}
        else{this.actualLanguage = 'FR'}
    },


  saveMyAgreement(){
        let payload = { "putAction": 'SignPolicy',"policyVersion":'Policy_2019_11_20_V01'}

        this.$store.dispatch('sessionStore/updateProfile', payload)
        .then((response) => {

          if(response.data.Code=='OK'){
              if (this.actualLanguage == "FR"){window.alert("Signature enregistré.")}else{window.alert('Signature saved.')}}
          else {
              if (this.actualLanguage == "FR"){window.alert("Erreur d'enregistrement de signature.")}else{window.alert('Signature not saved.')}}
          window.location.reload()
        })
    },


    openUtilizationConditions() {
      var localUrl ='';
      if (this.actualLanguage == 'FR'){
        localUrl =process.env.VAR_CONDITION_UTILIZATION_LINK_FR;
      }
      if (this.actualLanguage == 'EN'){
        localUrl =process.env.VAR_CONDITION_UTILIZATION_LINK_EN;
      }      
      window.open(localUrl, '_blank');  
    },


    openConfidentialityPolitics() {
      var localUrl ='';
      if (this.actualLanguage == 'FR'){
        localUrl =process.env.VAR_POLICY_CONFIDENTIALITY_LINK_FR;
      }
      if (this.actualLanguage == 'EN'){
        localUrl =process.env.VAR_POLICY_CONFIDENTIALITY_LINK_EN;
      }      
      window.open(localUrl, '_blank');  
    },


  },

  mounted() {
    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
    this.refresh()
 }

 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// PolicyAgreement.vue?40d34f77